/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeprecatedPagination } from './DeprecatedPagination';
import {
    DeprecatedPaginationFromJSON,
    DeprecatedPaginationFromJSONTyped,
    DeprecatedPaginationToJSON,
} from './DeprecatedPagination';
import type { Facet } from './Facet';
import {
    FacetFromJSON,
    FacetFromJSONTyped,
    FacetToJSON,
} from './Facet';
import type { OrderHistory } from './OrderHistory';
import {
    OrderHistoryFromJSON,
    OrderHistoryFromJSONTyped,
    OrderHistoryToJSON,
} from './OrderHistory';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * Representation of an Order History List
 * @export
 * @interface OrderHistoryList
 */
export interface OrderHistoryList {
    /**
     * List of order history items
     * @type {Array<OrderHistory>}
     * @memberof OrderHistoryList
     */
    orders?: Array<OrderHistory>;
    /**
     * List of sorts
     * @type {Array<Sort>}
     * @memberof OrderHistoryList
     */
    sorts?: Array<Sort>;
    /**
     * 
     * @type {DeprecatedPagination}
     * @memberof OrderHistoryList
     */
    pagination?: DeprecatedPagination;
    /**
     * List of facets
     * @type {Array<Facet>}
     * @memberof OrderHistoryList
     */
    facets?: Array<Facet>;
}

/**
 * Check if a given object implements the OrderHistoryList interface.
 */
export function instanceOfOrderHistoryList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OrderHistoryListFromJSON(json: any): OrderHistoryList {
    return OrderHistoryListFromJSONTyped(json, false);
}

export function OrderHistoryListFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderHistoryList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orders': !exists(json, 'orders') ? undefined : ((json['orders'] as Array<any>).map(OrderHistoryFromJSON)),
        'sorts': !exists(json, 'sorts') ? undefined : ((json['sorts'] as Array<any>).map(SortFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : DeprecatedPaginationFromJSON(json['pagination']),
        'facets': !exists(json, 'facets') ? undefined : ((json['facets'] as Array<any>).map(FacetFromJSON)),
    };
}

export function OrderHistoryListToJSON(value?: OrderHistoryList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'orders': value.orders === undefined ? undefined : ((value.orders as Array<any>).map(OrderHistoryToJSON)),
        'sorts': value.sorts === undefined ? undefined : ((value.sorts as Array<any>).map(SortToJSON)),
        'pagination': DeprecatedPaginationToJSON(value.pagination),
        'facets': value.facets === undefined ? undefined : ((value.facets as Array<any>).map(FacetToJSON)),
    };
}

